import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { TextInput } from 'SRC/ui/FormElements'
import config from 'SRC/config/config.json'

export const Password = () => {
  const { t } = useTranslation('common')

  const passwordField = {
    id: 'password',
    name: 'password',
    type: 'password',
    label: t('Nova šifra'),
    isRequired: true
  }

  return <TextInput {...passwordField} />
}
